import React, { useEffect, useState } from "react";
import {Chart as ChartJS, ArcElement, Tooltip} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Pie } from "react-chartjs-2";

ChartJS.register(
  ArcElement,
  Tooltip,
  ChartDataLabels
);

const colors = [
  "#36A2EB",
  "#4BC0C0",
  "#FFCE56",
  "#FF6384",
  "#9966FF",
  "#FF9F40",
  "#2ecc71",
];

function ByIndustry({ chart_data }) {
  const [label, setLabel] = useState([]);
  const [values, setValues] = useState([]);
  const [data, setData] = useState({labels: [], datasets: []});
  const [options, setOptions] = useState({});
  const [sectorMapping, setSectorMapping] = useState({});
  const [actualValues, setActualValues] = useState([]);

  useEffect(() => {
    let sector = [];
    let percentages = [];
    let actualAmounts = [];
    let mapping = {};

    let user = {};
    let currencies = [];

    try {
      user = JSON.parse(localStorage.getItem("user") || "{}");
      currencies = JSON.parse(localStorage.getItem("currency_rates") || "[]");
    } catch (error) {
      console.error("Error reading currency data:", error);
    }

    const defaultCurrencyId = Number(user?.default_currency_id || 1);
    const selectedCurrency = currencies.find((currency) => Number(currency.value) === defaultCurrencyId);
    const symbol = selectedCurrency?.symbol || (defaultCurrencyId === 1 ? "₹" : "");
    const conversionRateToINR = Number(selectedCurrency?.conversion_rate_to_inr) || 1;
    const amountDivisor = defaultCurrencyId === 1 ? 10000000 : 1000;
    const amountSuffix = defaultCurrencyId === 1 ? "Cr" : "K";
    const total_amount = chart_data?.reduce((sum, item) => sum + Number(item.total_amount || 0), 0) || 0;

    if (total_amount === 0) {
      setLabel([]);
      setValues([]);
      setActualValues([]);
      setSectorMapping({});
      return;
    }

    // ------------------------------------
    // Process industry data
    // ------------------------------------
    chart_data?.forEach(
      (item) => {const totalAmount = Number(item.total_amount || 0);
      const percentage = (totalAmount / total_amount) * 100;
      const convertedAmount = totalAmount / conversionRateToINR;
      const displayAmount = convertedAmount / amountDivisor;
      if (item.id === 7) {
        sector.push("Healthcare");
        percentages.push(Number(percentage.toFixed(1)));
        actualAmounts.push(displayAmount);
        mapping["Healthcare"] = [7];
      } else {
        sector.push(item.industry_name);

        percentages.push(
          Number(percentage.toFixed(1))
        );

        actualAmounts.push(
          displayAmount
        );

        mapping[item.industry_name] = [
          item.id,
        ];
      }
    });

    setLabel(sector);
    setValues(percentages);
    setActualValues(actualAmounts);
    setSectorMapping(mapping);

    // ------------------------------------
    // Build chart data
    // ------------------------------------
    setData({
      labels: sector,

      datasets: [
        {
          // Pie values are percentages
          data: percentages,

          // Actual converted amounts
          actualData: actualAmounts,

          backgroundColor: colors.slice(
            0,
            percentages.length
          ),

          borderWidth: 0,
        },
      ],
    });

    // ------------------------------------
    // Chart options
    // ------------------------------------
    setOptions({
      responsive: true,
      maintainAspectRatio: false,

      layout: {
        padding: {
          top: 12,
          bottom: 12,
          left: 15,
          right: 12,
        },
      },

      plugins: {
        legend: {
          display: true,
          position: "right",

          labels: {
            boxWidth: 10,
            boxHeight: 10,
            padding: 4,

            font: {
              size: 12,
            },
          },
        },

        datalabels: {
          color: "#000",

          anchor: "end",
          align: "end",
          offset: -3,

          formatter: (value) => {
            return Number(value) > 1
              ? `${Number(value).toFixed(1)}%`
              : "";
          },

          font: {
            weight: "bold",
            size: 10,
          },
        },

        tooltip: {
          callbacks: {
            label: (context) => {
              const actual =
                context.dataset.actualData?.[
                  context.dataIndex
                ] || 0;

              // IMPORTANT:
              // Use Chart.js value instead of React state
              // to avoid undefined percentage.
              const percentage =
                Number(context.parsed || 0);

              return `${percentage.toFixed(
                1
              )}% : ${symbol} ${Number(
                actual
              ).toFixed(
                2
              )} ${amountSuffix}`;
            },
          },
        },
      },

      onHover: (event, elements) => {
        if (elements.length > 0) {
          event.native.target.style.cursor =
            "pointer";
        } else {
          event.native.target.style.cursor =
            "default";
        }
      },
    });
  }, [chart_data]);

  return (
    <div
      style={{
        display: "flex",
        width: "280px",
        alignItems: "center",
      }}
    >
      {data?.datasets?.length > 0 && (
        <Pie
          data={data}
          options={options}
        />
      )}
    </div>
  );
}

export default ByIndustry;